import { TreeviewLinkType } from 'sigma-mappings';
import globalEventBus from '@/services/globalEventBus';
import events from '@/domain/events/treeview';

export default {
  inject: ['tree'],
  created() {
    this.initTreeviewInjectionListeners();
  },
  beforeDestroy() {
    this.stopTreeviewInjectionListeners();
  },
  methods: {
    initTreeviewInjectionListeners() {
      globalEventBus.on(events.onNodeClick, this.onClickNodeHandler, this);
    },
    stopTreeviewInjectionListeners() {
      globalEventBus.off(events.onNodeClick, this.onClickNodeHandler, this);
    },
    onClickNodeHandler(node) {
      const { currentRouteModuleSubtype, currentPage } = this.$route.meta;
      if (node.clickType === TreeviewLinkType.LINK) {
        const routeData = this.$router.resolve({
          name: currentPage ?? 'asset.asset-id',
          params: {
            installationId: node.installationId,
            assetId: node.id,
          },
          query: {
            redirectedFrom: currentRouteModuleSubtype,
          },
        });
        window.open(routeData.href, '_blank');
      }
    },
  },
};
